export default __webpack_public_path__ + "static/media/likeDone.8b5110ea.svg";